import { render, staticRenderFns } from "./stamp.vue?vue&type=template&id=15dd8643&scoped=true&"
import script from "./stamp.vue?vue&type=script&lang=js&"
export * from "./stamp.vue?vue&type=script&lang=js&"
import style0 from "./stamp.vue?vue&type=style&index=0&id=15dd8643&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd8643",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,DialogStamp: require('/app/components/dialog/stamp.vue').default})
